export default "__VITE_ASSET__16L0Zrr7__"